module.exports = __webpack_public_path__ + "img/document.b3ae4d39.svg";